export default __webpack_public_path__ + "static/media/shlop.d4944d69.ttf";